module.exports = __webpack_public_path__ + "media/images/element/coming-soon-e3ffe0c35899e61bdd14a0a21e20e6c1.svg";